import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Grid, styled } from '@mui/material';
import { useNavigate } from 'react-router';
import { AccessData } from './access-input';
import logoGalenaEdupass from '@/assets/images/logos/galena.svg';
import loginBg from '@/assets/images/png/login-bg.png';
import { session_path } from '@/utils/routes';

const StyledGrid = styled(Grid)(() => ({
  minHeight: '100vh',
  backgroundColor: '#FFFFFF',
}));

const StyledImageSection = styled('div')(() => ({
  backgroundImage: `url('${loginBg}')`,
  width: '100%',
  height: '100%',
  backgroundSize: 'cover',
}));

const StyledLogo = styled('img')({
  width: '157px',
});

const BackButton = styled(Button)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(2),
  left: theme.spacing(2),
}));

export const ForgotPassword = () => {
  const navigate = useNavigate();

  const handleBackToEmail = () => {
    navigate(session_path());
  };

  return (
    <StyledGrid container>
      <Grid justifyContent="center" display="flex" size={{ xs: 12, md: 6 }}>
        <Box
          width="100%"
          maxWidth={360}
          display="flex"
          flexDirection="column"
          gap={4}
          justifyContent="center"
        >
          <BackButton onClick={handleBackToEmail}>
            <ArrowBackIcon sx={{ fontSize: 'small' }} /> voltar
          </BackButton>
          <StyledLogo src={logoGalenaEdupass} alt="Galena" />
          <AccessData />
        </Box>
      </Grid>
      <Grid display={{ xs: 'none', md: 'flex' }} size={{ md: 6 }}>
        <StyledImageSection />
      </Grid>
    </StyledGrid>
  );
};
